import {createContext,  useState} from 'react';
const UserContext = createContext(null)

function UserProvider({children}) {

    // const [lang, setLang] = useState(null);
    const [userInfo, setUserInfo] = useState(null);


    return (
        <UserContext.Provider value={{ setUserInfo, userInfo}}>
            {children}
        </UserContext.Provider>
    );
}

export {UserContext, UserProvider};
